import fp from 'lodash/fp'
import {
  finalEditableFieldValue,
  isEditableField,
  Etunimet,
  Sukunimi,
} from 'todistukset-common/src/vtj/types/editable-field.type'

interface PersonNames {
  firstNames: Etunimet | null
  lastName: Sukunimi | null
}

export const displayNameOf = ({ firstNames, lastName }: PersonNames): string =>
  [firstNames, lastName]
    .filter((name) => isEditableField(name))
    .map((name) => finalEditableFieldValue(name))
    .join(' ')

export const reversedDisplayNameOf = ({
  firstNames,
  lastName,
}: PersonNames): string =>
  [lastName, firstNames]
    .filter((name) => isEditableField(name))
    .map((name) => finalEditableFieldValue(name))
    .join(', ')

export const hasName = ({ firstNames, lastName }: PersonNames): boolean =>
  !fp.isEmpty(finalEditableFieldValue(firstNames)) &&
  !fp.isEmpty(finalEditableFieldValue(lastName))
